<template>
  <NxSelectReduced
    :value="localValue"
    :options="listOptions"
    :labelText="variable.text + ':'"
    id="selectFuncionario"
    :placeholder="'Selecione o(s) ' + variable.text + '(s)'"
    :multiple="multiple"
    :isDisabled="isDisabled"
    @update:value="handleValueUpdate"
  ></NxSelectReduced>
</template>
<script>
import employeeTypes from '@/enums/enumEmployeeTypes.js'
import { JWTService } from '@/shared/services/jwt'
import Roles from '@/shared/utils/roles.js'
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'

import AccountRepository from '@/shared/http/repositories/configurations/account.js'
import EmployeeRepository from '@/shared/http/repositories/configurations/employee.js'

export default {
  name: 'NxSelectFuncionario',
  mixins: [useReactiveModelMixin('value')],
  props: {
    variable: {
      type: Object,
      required: true,
      default: function () {
        return {}
      }
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    initialValue: {
      type: [Object, null],
      required: false
    }
  },
  data () {
    return {
      listOptions: [],
      selected: null,
      isAdmin: false,
      employeeTypes: employeeTypes
    }
  },
  created () {
    this.checkIsAdmin()
    this.onLoadEmployeesFromUser()
  },
  methods: {
    onLoadEmployeesFromUser () {
      if (this.isAdmin) {
        this.onLoadEmployee()
      } else {
        AccountRepository.GetAllFromUser()
          .then((res) => {
            this.listOptions = res.data
              .filter((x) => x[this.variable.idType] != null)
              .map((x) => ({
                value: x[this.variable.idType],
                text: x.pessoa.nome
              }))
            if (this.initialValue) this.localValue = this.initialValue
          })
          .catch((err) => {
            toast.error(
              `Não foi possível carregar a lista de  ${this.variable.text}`,
              'Erro'
            )
            console.error(err)
          })
      }
    },
    onLoadEmployee () {
      EmployeeRepository.GetAll()
        .then((res) => {
          this.listOptions = res.data.content
            .filter((x) => x[this.variable.idType] != null)
            .map((x) => ({
              value: x[this.variable.idType],
              text: x.pessoa.nome
            }))
          if (this.initialValue) this.localValue = this.initialValue
        })
        .catch((err) => {
          toast.error(
            `Não foi possível carregar a lista de  ${this.variable.text}`,
            'Erro'
          )
          console.error(err)
        })
    },
    checkIsAdmin () {
      this.isAdmin = JWTService.GetRoles().some(
        (role) => role === Roles.ADMINISTRADOR
      )
      if (!this.isAdmin) this.onlyShowActive = true
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectFuncionario.vue